import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const MessageQuestion = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M8.24021 7.19397C7.88367 7.46676 7.49232 7.76618 7.49232 8.42347C7.49232 8.60456 7.54972 8.78564 7.54972 8.78564H8.58286C8.58286 8.32686 8.86969 8.0732 9.18686 7.7927C9.57911 7.4458 10.0178 7.05784 10.0178 6.19011C10.0178 5.28469 9.27163 4.5 8.12369 4.5C6.57397 4.5 6 5.94867 6 5.94867L7.14794 6.37119C7.14794 6.37119 7.37753 5.70722 8.12369 5.76758C8.52547 5.76758 8.81245 6.00903 8.81245 6.37119C8.81245 6.75614 8.53851 6.96574 8.24021 7.19397Z"
      fill="currentColor"
    />
    <path d="M7.49987 9.42859H8.57128V10.5H7.49987V9.42859Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 13H4L2.5547 13.9635C1.89014 14.4066 1 13.9302 1 13.1315V3.5C1 2.67157 1.67157 2 2.5 2H13.5C14.3284 2 15 2.67157 15 3.5V11.5C15 12.3284 14.3284 13 13.5 13ZM13.5 11.5H3.54584L2.5 12.1972V3.5H13.5V11.5Z"
      fill="currentColor"
    />
  </Icon>
));

export default MessageQuestion;
